import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/HomeView.vue"),
  },
  {
    path: "/menu",
    name: "Menus",
    component: () => import("@/views/MenusView.vue"),
  },
  {
    path: "/reserveren",
    name: "Reserveren",
    component: () => import("@/views/ReserverenView.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/views/ContactView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  to.meta.scrollToTop = true;
  if (to.meta.scrollToTop) {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

  }
  document.title = `Tahdik - ${to.name}`;
  next();
});

export default router;
